import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { InViewSimpleTransition } from '../../shared/utils/animations/transitions'
import { useWindowSize } from '@uidotdev/usehooks'
import './styles.scss'

MediaTextContentLayout.propTypes = {
  data: PropTypes.object,
}
const MAX_MOBIL_DEVICES = 869

export default function MediaTextContentLayout({ data }) {
  const targetRef = useRef(null)
  const { width } = useWindowSize()

  const [usingMovilScreen, setusingMovilScreen] = useState(width <= MAX_MOBIL_DEVICES)

  const updateScreenWidth = (_width) => {
    setusingMovilScreen(_width <= MAX_MOBIL_DEVICES)
  }
  // console.log(data)
  const main_content = {
    top_title: data?.top_title ?? '',
    main_title: data?.main_title ?? '',
    image: data?.image ?? { url: '', alt: '' },
    content_fields: data?.content_fields ?? [],
    button_link: data?.button_link ?? { url: '#', target: '', title: '' },
  }

  useEffect(() => {
    updateScreenWidth(width)
  }, [width])

  return (
    <div className="MediaTextContentLayout" ref={targetRef}>
      <div className="main-mediacontent-container">
        <div className="container-left">
          <InViewSimpleTransition
            type={usingMovilScreen ? 'fade' : 'slide'}
            parent={targetRef}
            slide_direction={'right'}
          >
            <img src={main_content.image.url} alt={main_content.image.alt} />
          </InViewSimpleTransition>
        </div>
        <InViewSimpleTransition className="container-right" type={'fade'} parent={targetRef}>
          <pre>{main_content.top_title}</pre>
          <h2>{main_content.main_title}</h2>
          <div className="content-items">
            {main_content.content_fields.map((item, index) => {
              return (
                <div className="item" key={index}>
                  <h3>
                    <span className="numberIcon">{(index + 1).toString().padStart(2, '0')}</span>{' '}
                    {item.title}
                  </h3>
                  <p>{item.content}</p>
                </div>
              )
            })}
          </div>
          {main_content.button_link?.title && (
            <a
              href={main_content.button_link?.url}
              className="action-button"
              target={main_content.button_link.target}
            >
              {main_content.button_link?.title}
            </a>
          )}
        </InViewSimpleTransition>
      </div>
    </div>
  )
}
